import Store from 'store/store';
import { getSize } from 'utils/bolt/client';

export * from 'utils/bolt/client.js';

export function isDesktopSize(size) {
	return !!(size?.toLowerCase()?.includes('desktop'));
}

export function updateClientSize() {
	const size = getSize(undefined, undefined, true);
	Store.get().client.set({
		deviceWidthSize: size,
		deviceSize: size,
		isDesktopSize: isDesktopSize(size)
	});
}